module.exports = "/_next/static/images/7226621946a9e75e4c68941c437d84c9-phone-xs.png";